import { MenuIcon as MenuIconComponent } from '@chakra-ui/menu';
import { HTMLChakraProps } from '@chakra-ui/system';
import * as React from 'react';

export type IMenuIconProps = HTMLChakraProps<'span'>;

export const MenuIcon: React.FunctionComponent<IMenuIconProps> = (props) => {
  return <MenuIconComponent {...props} />;
};
